module.exports = __webpack_public_path__ + "img/bg103_18.9bca2a57.png";